export default defineNuxtRouteMiddleware((to, from) => {
  const profile = useProfileStore();
  const hasPlayedWelcome = useNomadStorage('hasPlayedWelcome', false);
  if (
    to.path !== '/bienvenue' &&
    profile.accessType === 'marine' &&
    !hasPlayedWelcome.value
  ) {
    hasPlayedWelcome.value = true;
    return navigateTo('/bienvenue');
  }
});
